import { onboarding } from 'services/analytics/events';

export const trackingOnboardingStart = () => {
  return onboarding.start();
};

export const trackingOnboardingConnectAppsView = () => {
  return onboarding.connectApps.view();
};

export const trackingOnboardingExtensionsView = () => {
  return onboarding.extension.view();
};

export const trackingOnboardingLoaderView = () => {
  return onboarding.loader.view();
};

export const trackingOnboardingOrganizationSetupView = () => {
  return onboarding.organization.setup.view();
};

export const trackingOnboardingAddYourTeamView = () => {
  return onboarding.organization.invite.view();
};

export const trackingOnboardingComplete = () => {
  return onboarding.complete();
};
